function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { forEach, map } from 'lodash';
export var DocsCV = /*#__PURE__*/function () {
  function DocsCV() {
    _classCallCheck(this, DocsCV);
    _defineProperty(this, "hayDocs", false);
    _defineProperty(this, "hayTipos", false);
  }
  return _createClass(DocsCV, [{
    key: "updateDocs",
    value: function updateDocs(docs) {
      this.docsList = docs.list;
      this.hayDocs = true;
      if (this.hayTipos) this._clasificaDocs();
    }
  }, {
    key: "_clasificaDocs",
    value: function _clasificaDocs() {
      var _this = this;
      // limpiar todos los tipos
      forEach(this.tiposDocCv, function (t) {
        t.docs = [];
        t.vacio = true;
      });
      forEach(this.gruposDocCv, function (g) {
        return g.vacio = true;
      });

      // para todos los documentos, clasificar donde toca
      forEach(this.docsList, function (doc) {
        _this._clasificaDoc(doc);
      });
    }
  }, {
    key: "updateTipos",
    value: function updateTipos(tipos) {
      var _this2 = this;
      this.hayTipos = true;
      this.tiposDocCv = {};
      this.gruposDocCv = map(tipos.gruposDocList(), function (g) {
        var grupo = {
          g: g,
          vacio: true,
          list: []
        };
        grupo.list = _this2._tiposParaGrupo(grupo, g);
        return grupo;
      });
      if (this.hayDocs) this._clasificaDocs();
    }
  }, {
    key: "_tiposParaGrupo",
    value: function _tiposParaGrupo(grupo, g) {
      var _this3 = this;
      return map(g.list, function (t) {
        var tipo = {
          t: t,
          vacio: true,
          grupo: grupo,
          docs: []
        };
        _this3.tiposDocCv[t.tipo] = tipo;
        return tipo;
      });
    }
  }, {
    key: "nuevoDoc",
    value: function nuevoDoc(item) {
      this.docsList.unshift(item);
      if (this.hayDocs && this.hayTipos) this._clasificaDoc(item, true);
    }
  }, {
    key: "_clasificaDoc",
    value: function _clasificaDoc(doc) {
      var esnuevo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var t = this.tiposDocCv[doc.tipo];
      if (!t) {
        console.error('Tipo no encontrado clasificando documento');
        return;
      }
      if (esnuevo) t.docs.unshift(doc);else t.docs.push(doc);
      t.vacio = false;
      t.grupo.vacio = false;
    }
  }, {
    key: "quitarDocDeGrupo",
    value: function quitarDocDeGrupo(grupo, docBorrado) {
      // en cada tipo, buscar si está el documento
      grupo.list.forEach(function (ttipo) {
        var existe = ttipo.docs.findIndex(function (doc) {
          return doc.iddocint === docBorrado.iddocint;
        });
        if (existe > -1) ttipo.docs.splice(existe, 1);
        ttipo.vacio = !ttipo.docs.length;
      });
    }
  }]);
}();